import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Tooltip } from "primereact/tooltip";
import { useNavigate } from "react-router";
import "./CourseModal.scss";
import updateIconImg from "../../assets/updateIconImg.png";
import deleteIconImg from "../../assets/deleteIcon.png";
import addIcon from "../../assets/addWhiteIcon.png";
import Excalmation from "../../assets/Exclamation.png";
import ModalHeader from "../../components/Header/ModalHeader";
import DialogComponent from "../../components/Dialog";
import CourseForm from "./CourseForm";
import {
  deleteCourse,
  getCoursesFromServer,
  getPublishCourse,
} from "../../services/CourseService";

function getUniqueValuesByKey(data, key) {
  const values = data.map((data) => data[key]);
  return [...new Set(values)];
}
function CourseView() {
  const [courses, setCourses] = useState([]);
  // const [dataitem, setDataitem] = useState([]);
  const [categoryType, setCategoryType] = useState([]);
  const [uploadedDateTime, setUploadedDateTime] = useState([]);
  const [showAddCourseModal, setShowAddCourseModal] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [filters, setFilters] = useState({});
  const [selectedCourses, setSelectedCourses] = useState([]);
  const navigate = useNavigate();
  const toast = useRef(null);

  const fetchCourses = async (page, pageSize) => {
  try {
    const result = await getCoursesFromServer(page, pageSize);
    const sorted = result.data.sort((a, b) => a.title.localeCompare(b.title));

    setCourses(sorted);
    setPage(result.page);
    setPageSize(result.pageSize);
    setTotalCount(result.total); 
  } catch (error) {
    console.error("Error fetching courses:", error);
    setCourses([]);
    setTotalCount(0);
  }
};
  useEffect(() => {
    fetchCourses(page,pageSize);
  }, [page,pageSize]);

  useEffect(() => {
    setCategoryType(getUniqueValuesByKey(courses, "categoryType"));
    setUploadedDateTime(getUniqueValuesByKey(courses, "uploadedDateTime"));
  }, [courses]);

  const handleModalClose = (page = 1, pageSize = 10) => {
  setShowAddCourseModal(false);
  fetchCourses(page, pageSize);
};

  const handleAddCourseClick = () => {
    setShowAddCourseModal(true);
  };
  const handlePublishToggle = async (rowData) => {
    if (rowData.is_published) {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "Course is already published!",
        life: 3000,
      });
      return;
    }
    confirmDialog({
      message:
        "Do you want to publish this course? Please check if content is uploaded in this course.",
      header: "Confirmation",
      icon: "pi pi-info-circle",
      accept: async () => {
        try {
          await getPublishCourse(rowData.id);
          setCourses((prev) =>
            prev.map((course) =>
              course.id === rowData.id
                ? { ...course, is_published: true }
                : course
            )
          );
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Course successfully published!",
            life: 3000,
          });
        } catch (error) {
          console.error("Publish error:", error);
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Failed to publish course.",
            life: 3000,
          });
        }
      },
    });
  };
  const onFilter = (e, field) => {
    const value = e.target.value.toLowerCase();
    const newFilters = { ...filters };
    newFilters[field] = value;
    setFilters(newFilters);
  };
  const searchTemplate = (field) => {
    const placeholderText = field.includes(".")
      ? `Search ${field
        .split(".")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")}`
      : `Search ${field}`;
    return (
      <InputText
        value={filters[field] || ""}
        onChange={(e) => onFilter(e, field)}
        placeholder={placeholderText}
        className="p-column-filter"
      />
    );
  };
  const filteredData = courses.filter((item) =>
    Object.keys(filters).every((key) => {
      const keys = key.split(".");
      const value = keys.reduce((acc, k) => acc?.[k], item);
      return value?.toString().toLowerCase().includes(filters[key]);
    })
  );
  const renderTooltipComponent = ({ validStatus, remarks, id }) => {
    if (validStatus === "Valid" || !remarks) return null;
    return (
      <>
        <Tooltip target={`#tooltip_${id}`} mouseTrack>
          <div className="tooltip-content">{remarks}</div>
        </Tooltip>
        <span id={`tooltip_${id}`} data-testid="Exclamation">
          <img src={Excalmation} alt="Exclamation" />
        </span>
      </>
    );
  };
  const handleDeleteCourses = async () => {
    if (selectedCourses.length === 0) {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "Please select at least one course to delete.",
        life: 3000,
      });
      return;
    }
    confirmDialog({
      message: `Are you sure you want to delete the selected course`,
      header: "Confirmation",
      icon: "pi pi-info-circle",
      accept: async () => {
        let successCount = 0;
        let failedCount = 0;

        for (const course of selectedCourses) {
          try {
            await deleteCourse(course.id);
            successCount++;
          } catch (error) {
            console.error("Error deleting course:", error.message);
            toast.current.show({
              severity: "warn",
              summary: "Warning",
              detail: error.message || "Failed to delete course.",
              life: 5000,
            });
            failedCount++;
          }
        }
        if (successCount > 0) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: `Course deleted successfully.`,
            life: 3000,
          });
        }
        setSelectedCourses([]);
        fetchCourses();
      },
    });
  };

  const handleTablePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
  };
  return (
    <>
      <Toast ref={toast} />
      <div className="masterScreen">
        <div className="grid flex justify-content-end mb-4" style={{ marginLeft: '49.5rem'}}>
          <div className="sm:col-12 md:col-6 button_section">
            <div className="flex justify-content-end align-items-center mt-4 mb-2 gap-18 w-full">
              <div className="grid flex justify-content-end mb-4">
                <div className="md:col-6 col-div"></div>
                <div className="sm:col-12 md:col-6 button_section">
                  <div className="flex justify-content-end align-items-center mb-2 gap-18 w-full">
                    <div className="flex gap-2">
                      <Button
                        className="master-updateBtn"
                        label="Update"
                        severity="info"
                        icon={<img src={updateIconImg} alt="Update icon" />}
                        outlined
                        disabled={selectedCourses.length !== 1}
                        tooltip="Update Course"
                        tooltipOptions={{ position: "bottom", event: "both" }}
                        onClick={() => {
                          if (selectedCourses.length === 1) {
                            const courseData = selectedCourses[0];
                            navigate(`/course?tab=edit`, {
                              state: {
                                mode: "update",
                                course: courseData,
                              },
                            });
                            handleAddCourseClick();
                          }
                        }}
                      />
                      <Button
                        className="master-deleteBtn"
                        label="Delete"
                        severity="danger"
                        icon={<img src={deleteIconImg} alt="Delete icon" />}
                        outlined
                        disabled={selectedCourses.length === 0}
                        onClick={handleDeleteCourses}
                      />
                      <Button
                        className="addBtn"
                        label="Add New Course"
                        icon={<img src={addIcon} alt="Add icon" />}
                        disabled={selectedCourses.length > 0}
                        tooltip="Add New Course"
                        tooltipOptions={{ position: "bottom", event: "both" }}
                        onClick={() => {
                          navigate("/course?tab=add");
                          handleAddCourseClick();
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DataTable
          lazy
          className="table-viewport custom-tooltip"
          resizableColumns
          value={filteredData}
          size="small"
          dataKey="id"
          emptyMessage="No data found."
          filterDisplay="row"
          scrollable
          scrollHeight="700px"
          paginator
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          rows={pageSize}
          first={(page - 1) * pageSize}
          rowsPerPageOptions={[5, 10, 20, 50]}
          onPage={(e) => {
            const newPage = Math.floor(e.first / e.rows) + 1;
            const newPageSize = e.rows;
            handleTablePageChange(newPage, newPageSize);
          }}
          totalRecords={totalCount}
          selection={selectedCourses}
          onSelectionChange={(e) => setSelectedCourses(e.value)}
        >
          <Column selectionMode="multiple" header="Select" frozen />
          <Column frozen body={renderTooltipComponent} />
          <Column
            field="title"
            header="Course Title"
            filter
            showFilterMenu={false}
            filterPlaceholder="Search"
            filterElement={() => searchTemplate("title")}
          />
          <Column
            field="category.title"
            header="Course Category"
            filter
            showFilterMenu={false}
            filterPlaceholder="Search"
            filterElement={() => searchTemplate("category.title")}
          />
          <Column
            field="roles"
            header="Roles"
            body={(rowData) => rowData.roles?.join(", ") || "-"}
            filter
            showFilterMenu={false}
            filterPlaceholder="Search"
            filterElement={() => searchTemplate("roles")}
          />
          <Column
            field="published_date"
            header="Scheduled Publish Date"
            body={(rowData) => {
              const date = rowData.published_date;
              return date ? new Date(date).toISOString().split("T")[0] : "-";
            }}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          />
          <Column
            field="is_published"
            header="Publish Course"
            body={(rowData) => (
              <div className="custom-small-toggle">
                <InputSwitch
                  checked={rowData.is_published}
                  onChange={() => handlePublishToggle(rowData)}
                />
              </div>
            )}
          />
        </DataTable>
        <p className="text-sm">{totalCount} Total record</p>
      </div>
      <DialogComponent
        visible={showAddCourseModal}
        onHide={handleModalClose}
        header={<ModalHeader onClose={handleModalClose} backText="Back To Course" />}
        style={{ width: "100vw", maxWidth: "1000px", height: "100vh" }}
      >
        <CourseForm onClose={handleModalClose} onFormSubmit={() => setSelectedCourses([])} />
      </DialogComponent>
      <ConfirmDialog />
    </>
  );
}

export default CourseView;